import styled, { css } from 'styled-components';

import { IToastItem } from './ToastItem';

const transitionAxisX = (direction: 'right' | 'left') => {
  return css`
    @keyframes enter {
      0% {
        ${{
          transform: `translateX(${direction === 'right' ? '-' : ''}110%)`,
        }}
      }
      100% {
        transform: translateX(0);
      }
    }

    @keyframes out {
      0% {
        transform: translateX(0);
      }
      100% {
        ${{
          transform: `translateX(${direction === 'right' ? '-' : ''}110%)`,
        }}
      }
    }
  `;
};

export const ToastCard = styled.div<IToastItem.IToastCard>`
  position: relative;
  margin: 5px;
  width: 553px;
  min-height: 98px;
  max-height: 150px;
  background-color: ${({ theme, variant }) =>
    variant === 'success' ? theme.colors.primaryGreen500 : theme.colors.red500};
  border-radius: 12px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: ${({ open }) => (open ? 'enter' : 'out')} 0.3s;
  opacity: ${({ open }) => (open ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  ${({ direction }) => transitionAxisX(direction === 'left' ? 'right' : 'left')};

  :before {
    content: '';
    position: absolute;
    left: 0;
    bottom: ${({ variant }) => (variant === 'success' ? '0' : '10px')};
    opacity: 0.2;
    width: ${({ variant }) => (variant === 'success' ? '137px' : '166px')};
    height: 100%;
    background-image: url(${({ variant }) =>
      variant === 'success' ? '/static/svg/commons/success.svg' : '/static/svg/commons/error.svg'});
    background-repeat: no-repeat round;
    background-size: ${({ variant }) => (variant === 'success' ? '137px 94px' : '156px 159px')};
  }

  @media only screen and ${({ theme }) => theme.breakpoints.mobileL} {
    width: 100%;
    margin: 0;
  }
`;

export const StartContent = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
`;

export const IconStatus = styled.span<IToastItem.IIconStatus>`
  min-width: 51px;
  min-height: 51px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.gray0};
  border-radius: 26px;
  font-size: ${({ variant }) => (variant === 'success' ? '20px' : '26px')};

  :before {
    color: ${({ theme, variant }) =>
      variant === 'success' ? theme.colors.primaryGreen500 : theme.colors.red500};
  }
`;

export const MessageContainer = styled.div`
  margin: 0 16px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const Description = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
  margin-top: 3px;
`;

export const EndContent = styled.div`
  display: flex;
  gap: 16px;
`;

export const ButtonMore = styled.button`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
  display: flex;
  padding: 10px 24px;
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid ${({ theme }) => theme.colors.gray0};
  border-radius: 8px;
`;

export const ButtonClose = styled.button`
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  border: none;
  font-size: 11px;

  :before {
    color: ${({ theme }) => theme.colors.gray0};
  }
`;

export const ProgressBar = styled.div`
  position: absolute;
  height: 2px;
  bottom: 0;
  left: 8px;
  right: 8px;
  border-radius: 0 0 3px 3px;
  background: rgba(0, 0, 0, 0.19);
  display: flex;
`;

export const ProgressLine = styled.div<IToastItem.IProgress>`
  height: 2px;
  width: ${({ width }) => `${width}%`};
  background-color: ${({ theme }) => theme.colors.gray0};
  border-radius: 3px;
  transition: width 1s linear;
`;
